var Vendd = (function (Vendd) {
    'use strict';

    var tempPostCode = '';
    var tempPostCodeFirstAccess = true;
    var tempAreas = '';
    var countries = '';
    var taxAgencies = '';
    var vatStatuses = '';
    var validateAreas = false;
    var addressValEngine = '';
    var observable = '';
    var validationModel;

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetUserAccount, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetUserAccountSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetUserAccountFailure(response));
        }

        var options = {
            url: 'AccountService.svc/GetUserAccountViewModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditUser, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            if (response.success === true && response.code === "AccountEdit_OperationSuccesful") {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditUserSuccess(response));

                Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UpdateNewLetterVariables(3, null));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditUserFailed(response));
            }
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditUserFailed(response));
        }

        var options = {
            url: 'AuthService.svc/EditUser',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddresses, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressesFailed(response));
        }

        var url = envelope.message.data.addressType === 'shipping'
            ? 'AccountService.svc/GetShippingAddressesViewModel'
            : 'AccountService.svc/GetBillingAddressesViewModel';

        var options = {
            url: url,
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.SetDefaultAddress, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            // Vendd.MessageBus.publishAsync(Account, new Vendd.Account.Messages.SetDefaultAddressSuccess());
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.AddressModelChanged());
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.SetDefaultAddressFailure(response));
        }

        var url = envelope.message.data.addressType === 'shipping'
            ? 'CommonService.svc/SetDefaultShippingAddress'
            : 'CommonService.svc/SetDefaultBillingAddress';


        var options = {
            url: url,
            data: {
                addressId: envelope.message.data.addressId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.DeleteAddress, Vendd.Account, function (envelope) {
        function onSuccess(response) {

            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.AddressModelChanged());

        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.DeleteAddressFailure(response));
        }

        var url = envelope.message.data.addressType === 'shipping'
            ? 'CommonService.svc/DeleteShippingAddress'
            : 'CommonService.svc/DeleteBillingAddress';


        var options = {
            url: url,
            data: {
                addressId: envelope.message.data.addressId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditAddress, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressSuccess());
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressFailed(response));
        }

        var options = {
            url: 'AccountService.svc/EditUserAddress',
            data: {
                addressType: envelope.message.data.addressType,
                address: envelope.message.data.model
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.ConvertPointsToCoupons, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.ConvertPointsToCouponsSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.ConvertPointsToCouponsFailure(response));
            }
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.ConvertPointsToCouponsFailure(response));
        }
        var options = {
            url: 'EcomService.svc/ConvertPointsToCoupons',
            data: {
                accountId: envelope.message.data.accountId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressIfExists, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.CheckAddressIfExistsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.CheckAddressIfExistsFailure(response));
        }

        var options = {
            url: 'CommonService.svc/CheckAddressIfExists',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreasForPostCode, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAreasForPostCodeSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressFailed(response));
        }

        var options = {
            url: 'AccountService.svc/AreaLookUp',
            data: {
                countryCode: envelope.message.data.country,
                postalCode: envelope.message.data.postCode,
                selectedAreaCode: envelope.message.data.area
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCountries, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            countries = response;
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCountriesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCountriesFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetCountries',
            data: {
                selectedCountryCode: envelope.message.data.selectedCountryCode,
                addressType: envelope.message.data.addressType
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetPrefecture, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPrefectureSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPrefectureFailed(response));
        }

        var options = {
            url: 'AccountService.svc/PrefectureLookUp',
            data: {
                countryCode: envelope.message.data.countryCode,
                postalCode: envelope.message.data.postCode,
                area: envelope.message.data.area
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetPrefectures, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPrefecturesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPrefecturesFailed(response));
        }

        var options = {
            url: 'CachedServices/api/Geo/GetPrefectures?languageCode=' + envelope.message.data.languageCode + '&addressType=' + envelope.message.data.addressType + '&countryCode=' + envelope.message.data.countryCode + '&searchText=&limit=10000',
            method: 'GET',
            servicenamespace: '',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCities, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCitiesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCitiesFailed(response));
        }

        var options = {
            url: 'CachedServices/api/Geo/GetCities?languageCode=' + envelope.message.data.languageCode + '&addressType=' + envelope.message.data.addressType + '&countryCode=' + envelope.message.data.countryCode + '&prefectureName=' + encodeURIComponent(envelope.message.data.prefectureName) + '&searchText=&limit=10000',
            method: 'GET',
            servicenamespace: '',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreas, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAreasSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAreasFailed(response));
        }

        var options = {
            url: 'CachedServices/api/Geo/GetAreas?languageCode=' + envelope.message.data.languageCode + '&addressType=' + envelope.message.data.addressType + '&countryCode=' + envelope.message.data.countryCode + '&prefectureName=' + encodeURIComponent(envelope.message.data.prefectureName) + '&cityName=' + encodeURIComponent(envelope.message.data.cityName) + '&searchText=&limit=10000',
            method: 'GET',
            servicenamespace: '',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetPostCodes, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPostCodesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetPostCodesFailed(response));
        }

        var options = {
            url: 'CachedServices/api/Geo/GetPostCodes?languageCode=' + envelope.message.data.languageCode + '&addressType=' + envelope.message.data.addressType + '&countryCode=' + envelope.message.data.countryCode + '&prefectureName=' + encodeURIComponent(envelope.message.data.prefectureName) + '&cityName=' + encodeURIComponent(envelope.message.data.cityName) + '&areaName=' + encodeURIComponent(envelope.message.data.areaName) + '&searchText=' + envelope.message.data.searchText + '&limit=10000',
            method: 'GET',
            servicenamespace: '',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetStreets, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetStreetsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetStreetsFailed(response));
        }

        var options = {
            url: 'CachedServices/api/Geo/GetStreets?languageCode=' + envelope.message.data.languageCode + '&addressType=' + envelope.message.data.addressType + '&countryCode=' + envelope.message.data.countryCode + '&prefectureName=' + encodeURIComponent(envelope.message.data.prefectureName) + '&cityName=' + encodeURIComponent(envelope.message.data.cityName) + '&areaName=' + encodeURIComponent(envelope.message.data.areaName) + '&searchText=' + envelope.message.data.searchText + '&limit=10000',
            method: 'GET',
            servicenamespace: '',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllTaxAgencies, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            taxAgencies = response;
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllTaxAgenciesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllTaxAgenciesFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAllTaxAgencies',
            data: {
                countryCode: envelope.message.data.countryCode
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllVatStatuses, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            vatStatuses = response;
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllVatStatusesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllVatStatusesFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAllVatStatuses',

            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetVatInfo, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetVatInfoSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetVatInfoFailed(response));
        }

        var options = {
            url: 'EcomService.svc/GetVatInfo',
            data: {
                request: {
                    country: envelope.message.data.country,
                    vat: envelope.message.data.vat
                },              
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllAddressGroups, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllAddressGroupsSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAllAddressGroupsFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAllAddressGroups',
            data: {
                selectedAddressGroupId: parseInt(envelope.message.data.selectedAddressGroupId, 10)
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.RequestToDeleteUser, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToDeleteUserSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToDeleteUserFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/RequestToDeleteUser',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.RequestToExportData, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToExportDataSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.RequestToExportDataFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/RequestToExportData',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCouponInformations, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCouponInformationsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetCouponInformationsFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/GetCouponInformations',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.InvalidateCouponCode, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.InvalidateCouponCodeSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.InvalidateCouponCodeFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Account/InvalidateCouponCode',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.Account.GetNewAddress = function (model) {
        var newAddress = {
            IsInvoiceEnabled: model.IsInvoiceEnabled,
            IsReceiptEnabledForB2B: model.IsReceiptEnabledForB2B,
            IsDefault: false,
            FirstName: '',
            LastName: '',
            Title: '',
            Bell: '',
            AddressLine1: '',
            AddressLine2: '',
            Area: '',
            City: '',
            PostCode: '',
            Country: '',
            CountryDescription: '',
            Prefecture: '',
            Phones: '',
            SocialSecurityNumber: '',
            Mobiles: '',
            Fax: '',
            IsInvoice: false,
            InvoiceText: '',
            EInvoiceModuleEnabled: model.Configs.EInvoiceModuleEnabled,
            UserCanChangeValue: model.Configs.UserCanChangeValue,
            ReceiveEinvoice: null,
            CompanyName: '',
            Occupation: '',
            Headquarters: '',
            TaxIdentifier: '',
            TaxAgency: '',
            TaxAgencyId: -1,
            VatStatus: 0,
            AddressGroupId: -1,
            IsShippingRestrictedToResolvedCountry: model.Configs.IsShippingRestrictedToResolvedCountry
        };

        return newAddress;
    };

    /*remaining for return order js*/
    Vendd.Account.ValidateObservable = function (observ) {

        if (observ == undefined) {
            observ = observable;
        }
        var valOptions = {
            ValidationEngine: addressValEngine,
            valmodel: observ.model,
        };
        Vendd.DataValidation.ValidateModel(valOptions);
    };

    /*new messagebus for entiry address info*/
    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressInfo, Vendd.Account, function (envelope) {

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressInfoSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressInfoFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/Address/GetAddressInfo',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    /* Address Groups */

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressGroups, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressGroupsSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressGroupsFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAddressGroupsViewModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressGroup, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressGroupSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.GetAddressGroupFailed(response));
        }

        var options = {
            url: 'AccountService.svc/GetAddressGroupViewModel',
            data: {
                addressGroupId: envelope.message.data.addressGroupId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.DeleteAddressGroup, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.DeleteAddressGroupSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.DeleteAddressGroupFailure(response));
        }

        var options = {
            url: 'AccountService.svc/DeleteAddressGroup',
            data: {
                addressGroupId: envelope.message.data.addressGroupId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditAddressGroup, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressGroupSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.EditAddressGroupFailed(response));
        }

        var options = {
            url: 'AccountService.svc/EditAddressGroup',
            data: {
                addressGroup: envelope.message.data.model
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.Account.GetNewAddressGroup = function (model) {
        var newAddressGroup = {
            Id: -1,
            Name: '',
            Description: ''
        };

        return newAddressGroup;
    };

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressGroupIfExists, Vendd.Account, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.CheckAddressGroupIfExistsSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Account, new Vendd.Account.Messages.CheckAddressGroupIfExistsFailure(response));
        }

        var options = {
            url: 'AccountService.svc/FindAddressGroup',
            data: {
                addressGroup: envelope.message.data.model
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});